import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const fixedLogsConfigService = {
  getAll: async () => {
    return await axios.get(`${domain}/api/FixedLogsConfig`, { headers });
  },
  getByEmployee: async (employeeId) => {
    return await axios.get(`${domain}/api/FixedLogsConfig/employee/${employeeId}`, { headers });
  },
  create: async (payload) => {
    return await axios.post(`${domain}/api/FixedLogsConfig`, payload, { headers });
  },
  bulkCreate: async (payload) => {
    return await axios.post(`${domain}/api/FixedLogsConfig/bulk`, payload, { headers });
  },
  update: async (id, payload) => {
    return await axios.put(`${domain}/api/FixedLogsConfig/${id}`, payload, { headers });
  },
  delete: async (id) => {
    return await axios.delete(`${domain}/api/FixedLogsConfig/${id}`, { headers });
  },
};

export default fixedLogsConfigService;